var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15671",
    "data-name": "Group 15671",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2027",
    "data-name": "Rectangle 2027",
    width: 61,
    height: 61,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loupe",
    transform: "translate(6.914 6.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8001",
    "data-name": "Path 8001",
    d: "M150.783,4.636a15.806,15.806,0,1,1-3.774,16.279,15.806,15.806,0,0,1,3.774-16.279Zm2.351,20a12.441,12.441,0,1,0-3.671-8.824,12.478,12.478,0,0,0,3.671,8.824Zm0,0",
    transform: "translate(-146.161 0.001)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8002",
    "data-name": "Path 8002",
    d: "M16.961,287.479a4.159,4.159,0,0,1-5.882,5.882L.1,282.386,5.986,276.5Zm0,0",
    transform: "translate(28.635 -247.751)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8003",
    "data-name": "Path 8003",
    d: "M140.577,255.619c.4-.333.794-.685,1.165-1.057s.723-.768,1.06-1.17c.093-.111.182-.224.272-.337.1-.128.211-.25.31-.383l2.481,2.481-3.528,3.528-2.481-2.476c.13-.1.25-.206.381-.307C140.351,255.8,140.464,255.712,140.577,255.619Zm0,0",
    transform: "translate(-113.595 -226.397)",
    fill: "#3f2566"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSearch);
export default __webpack_public_path__ + "static/media/header-search.49ed1bdaf19a7388dafc324de18e6c73.svg";
export { ForwardRef as ReactComponent };